import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Hydrates the current guest discount % from `/api/guest/progress`.
 * Silently no-ops when unauthenticated or on network failure — the
 * discount chip in the header just hides itself.
 */
export function useGuestDiscount() {
  const [currentDiscount, setCurrentDiscount] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    axios
      .get(`${API}/guest/progress`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (typeof res.data?.discount === 'number') {
          setCurrentDiscount(res.data.discount);
        }
      })
      .catch(() => {});
  }, []);
  return currentDiscount;
}
